const locale = {
    locale: "en_US",
    yearFormat: "YYYY",
    monthFormat: "MMMM",
    fieldDateFormat: "MMM dd yyyy",
    dayFormat: "DD",
    shortWeekDays: ["S", "M", "T", "W", "T", "F", "S"],
    monthBeforeYear: true,
};
export default locale;
